import { TableCell, TableRow } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import styled from "styled-components";

type Props = {
  testId?: string;
};

export default function UserSkeletonRow({ testId }: Props) {
  return (
    <TableRow style={{ height: 60 }} data-testid={testId}>
      <TableCell>
        <NameCell>
          <Skeleton variant="circle" animation="wave" height={34} width={34} />
          <Skeleton variant="text" animation="wave" height={20} width={120} />
        </NameCell>
      </TableCell>
      <TableCell style={{ maxWidth: 300 }}>
        <Skeleton variant="text" animation="wave" height={20} width={180} />
      </TableCell>
      <TableCell>
        <Skeleton
          variant="rect"
          animation="wave"
          height={24}
          width={64}
          style={{ borderRadius: 16 }}
        />
      </TableCell>
      <TableCell>
        <AccessCell>
          <Skeleton variant="circle" animation="wave" height={17} width={17} />
          <Skeleton variant="text" animation="wave" height={20} width={72} />
        </AccessCell>
      </TableCell>
      <TableCell>
        <Skeleton variant="text" animation="wave" height={20} width={80} />
      </TableCell>
      <TableCell align="right">
        <ActionsCell>
          <Skeleton variant="circle" animation="wave" height={26} width={26} />
          <Skeleton variant="circle" animation="wave" height={26} width={26} />
        </ActionsCell>
      </TableCell>
    </TableRow>
  );
}

const NameCell = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
`;

const AccessCell = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 6px;
`;

const ActionsCell = styled.div`
  display: flex;
  justify-content: flex-end;
`;
